import styled from 'styled-components';
import { flexProps, borderProps, paddingProps, marginProps, widthProps } from './props';

export const Flex = styled.div`
  display: flex;
  ${flexProps};
  ${borderProps};
  ${paddingProps};
  ${widthProps};
  ${marginProps};
`;

export const FlexCenter = styled(Flex)`
  justify-content: center;
  align-items: center;
`;
